import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TableColumn } from '../../../../shared-components/data-table/data-table.component';
import { ChangelogDialogConfig } from '../../../../shared-components/changelog-dialog/changelog-dialog.component';

@Component({
  selector: 'app-protocol-factor-changelog',
  templateUrl: './protocol-factor-changelog.component.html',
  standalone: false
})
export class ProtocolFactorChangelogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any  ) {
    const columns: TableColumn[] = [
      { key: 'code', header: 'Factor Code' },
      { key: 'description', header: 'Description' },
      { key: 'createdBy', header: 'Created By' },
      { 
        key: 'createdAtUtc', 
        header: 'Created At',
        formatter: (value) => this.formatDate(value)
      },
      { key: 'changedBy', header: 'Changed By' },
      { 
        key: 'changedAtUtc', 
        header: 'Changed At',
        formatter: (value) => this.formatDate(value)
      }
    ];

    const config: ChangelogDialogConfig = {
      title: 'Change Log',
      subtitle: `Protocol factor : ${data.element?.code || '-'}`,
      apiEndpoint: `api/osh/protocol-factors/${data.factorId}/history`,
      columns: columns,
      backButtonText: 'Back'
    };

    Object.assign(this.data, config);
  }

  private formatDate(date: any): string {
    if (!date) return '-';
    const d = new Date(date);
    if (Number.isNaN(d.getTime())) return '-';
    const pad = (n: number) => String(n).padStart(2, '0');
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
  }
}
